// extracted by mini-css-extract-plugin
export default {"year-selector":"YearSelector_year-selector__qXUWU"};